import { Component, computed, inject, OnInit, Signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { PermissionService } from '../../core/security';
import { UserService } from '../../domains/user';
import { FieldErrorComponent } from "../../shared/field-error/field-error.component";

interface City {
    name: string;
    code: string;
}

@Component({
    selector: 'app-test-content-prime-ng',
    imports: [ButtonModule, CardModule, FloatLabelModule, InputTextModule, IconFieldModule, InputIconModule, SelectModule, TextareaModule, FieldErrorComponent],
    templateUrl: './test-content-prime-ng.component.html'
})
export class TestContentComponent implements OnInit {
    
    private messageService = inject(MessageService);
    private userService = inject(UserService);
    permissionService = inject(PermissionService);

    userContext = this.userService.userContext;
    userContextStringify: Signal<string> = computed(() => JSON.stringify(this.userContext()));
    
    cities: City[] | undefined;

    ngOnInit(): void {
        
        this.cities = [
            { name: 'New York', code: 'NYC' },
            { name: 'Trenton', code: 'EWT' },
            { name: 'Philadelphia', code: 'PHL' }
        ];

        this.cities.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            } else if (a.name > b.name) {
                return 1;
            } else {
                return 0;
            }
        });
    }

    onMessageTest() {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'This is a test message', life:100000});
    }

    onSubmitTest() {
        console.log('Submit');
    }
}
